import _ from 'lodash';
import React, { ReactNode, RefObject } from 'react';
import classnames from 'classnames';
import { BBCommonProps, BBEditableModeProps } from 'types/story';
import withCardTransitionContext from 'client/components/common/BuildingBlocks/BuildingBlockEnhancer';
import { ChildrenWithParentState } from 'client/components/common/BuildingBlocks/ChildrenWithParentState';
import css from './Box.scss';

type Props = BBCommonProps & { children: ReactNode };

class Box extends React.Component<Props> {
	renderEditable() {
		const props = { ...this.props.editableModeProps?.nodeProps };
		return this.renderDefault(props);
	}

	renderDefault(props: Partial<BBEditableModeProps['nodeProps']> = {}) {
		const { nodeProps } = this.props.uiConfig;
		const className = classnames(css.box, nodeProps.className, props.className);

		return (
			<div
				{...nodeProps}
				{...this.props.stateAttrs}
				{...this.props.eventListeners}
				{...props}
				data-box-type={_.get(this.props, ['uiConfig', 'componentProps', 'other', 'boxType'])}
				className={className}
				ref={this.props.containerRef as RefObject<HTMLDivElement>}
			>
				{this.props.isEditableMode ? (
					this.props.children
				) : (
					<ChildrenWithParentState states={this.props.parentStates}>
						{/* parent states can be received from parent Answer BB or parent Swipe BB */}
						{this.props.children}
					</ChildrenWithParentState>
				)}
			</div>
		);
	}

	render() {
		return this.props.isEditableMode ? this.renderEditable() : this.renderDefault();
	}
}

export default withCardTransitionContext(Box);
